import Vue from 'vue'
import Vuex from 'vuex'
import services from '@/helpers/services.js'

Vue.use(Vuex)

const idToken = window.localStorage.getItem('idToken')
const user = window.localStorage.getItem('user')

export default new Vuex.Store({
  state: {
    idToken: idToken ? JSON.parse(idToken) : null,
    user: user ? JSON.parse(user) : {},
    dynamic_img_url: '',
    cdn: 'https://daagiigaadskycargo.s3.ap-southeast-1.amazonaws.com',
    mainBranches: [
      // {
      //   key: 'oficer',
      //   name: 'Офицер салбар',
      //   branchCode: '天空8792',
      //   phone: '13474735577',
      //   region: '内蒙古自治区',
      //   league: '錫林郭勒盟',
      //   city: '二连浩特市',
      //   econZone: '二连边境经济技术合作区',
      //   address: '国门金街北区6号商铺爱蒙货代8792tenger cargo (өөрийн нэр утасны дугаарыг нөхөж бичнэ)'
      // },
      {
        key: 'bohiinurguu',
        name: 'Бөхийн өргөө салбар',
        branchCode: '天空0599',
        phone: '13474735577',
        region: '内蒙古自治区',
        league: '錫林郭勒盟',
        city: '二连浩特市',
        econZone: '二连边境经济技术合作区',
        address: '国门金街北区6号商铺爱蒙货代0599tenger cargo (өөрийн нэр утасны дугаарыг нөхөж бичнэ)'
      }
    ]
  },
  getters: {
    idTokenGetter (state) {
      return state.idToken
    },
    userDetailGetter (state) {
      return state.user
    },
    cdnGetter: (state) => state.cdn || JSON.parse(localStorage.getItem('cdn')),
    imgUrlGetter: (state) => state.dynamic_img_url || JSON.parse(localStorage.getItem('dynamic_img_url')),
    mainBranchesGetter: (state) => state.mainBranches
  },
  mutations: {
    authUser (state, userData) {
      state.idToken = userData.token
      window.localStorage.setItem('idToken', JSON.stringify(state.idToken))
    },
    addUserInfo (state, userData) {
      state.userInfo = userData
      window.localStorage.setItem('user', JSON.stringify(state.userInfo))
    },
    setCdnGetter (state, cdn) {
      state.cdn = cdn
      localStorage.setItem('cdn', cdn) // Хадгалах
    },
    SET_DYNAMIC_IMG_URL (state, url) {
      state.dynamic_img_url = url
    }
  },
  actions: {
    async authUserLoginPage ({ commit }, response) {
      commit('authUser', response)
    },
    async userAdd ({ commit }, response) {
      commit('addUserInfo', response)
    },
    async signin ({ commit }, authData) {
      return new Promise((resolve, reject) => {
        services.login(authData)
          .then((response) => {
            resolve(response)
          },
          error => {
            reject(error)
          })
      })
    },
    setDynamicImgUrl ({ commit }, url) {
      commit('SET_DYNAMIC_IMG_URL', url)
    }
  },
  modules: {
  }
})
